module.exports = __webpack_public_path__ + "img/477.b7f7bf37.png";